module.exports = __webpack_public_path__ + "assets/cyber_white.95b16ed4.svg";